import React, { useEffect } from 'react';
import * as notifications from 'lib/notifications';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { PermissionForm } from './PermissionForm';
import { IFilesContainerOutletContext } from './FilesContainer';

export function AttachedFilePermissionForm(props: {}) {
    let { fileId } = useParams();
    const navigate = useNavigate();

    const { setShowFolderActionButton } = useOutletContext<IFilesContainerOutletContext>();
    useEffect(() => {
        setShowFolderActionButton(false);
    });
    
    return (<>
        <PermissionForm title={"Redigera rättigheter"} fileId={fileId}
            cancel={() => navigate("..", { relative: "path" })}
            submit={async (data) => {
                console.log("onSubmit");
                console.log(data);
                try {
                    //await api.moveFile({ id: fileToMove.id, destinationId: data.fileId });
                    notifications.dispatch("Rättigheterna uppdaterades", 5);
                    //props.ok();
                    //setFileToEdit(null);
                    //refreshFileList();
                } catch (e) {
                    notifications.dispatchFromError("Fel vid uppdatering av rättigheter", e, 30);
                }
            }} />
    </>);
}
